import { HTMLAttributes, PropsWithChildren } from "react";
import { flexColumns, layoutBase, mainContainer } from "./styles.css";
import classNames from "classnames";

export const PageLayout = ({
  children,
  className,
}: PropsWithChildren<{
  className: string;
}>) => {
  return <div className={classNames(layoutBase, className)}>{children}</div>;
};

export const Section = ({
  children,
  withTopPadding,
  ...rest
}: PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & { withTopPadding?: boolean }
>) => {
  const variant = withTopPadding ? "withTopPadding" : "default";

  return (
    <div className={mainContainer[variant]} {...rest}>
      {children}
    </div>
  );
};

export const FlexColumns = ({ children }: PropsWithChildren) => {
  return <div className={flexColumns}>{children}</div>;
};
